import { applyMiddleware, createStore } from "redux";
import bookingReducer from "./booking/bookingReducer";
import bookingMiddleware from "./middlewares/bookingMiddleware";


const store = createStore(bookingReducer, applyMiddleware(bookingMiddleware));

export default store;